import { render, staticRenderFns } from "./gofixDefaultTables.vue?vue&type=template&id=4204b786&"
import script from "./gofixDefaultTables.vue?vue&type=script&lang=js&"
export * from "./gofixDefaultTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports